import useHttpMutation from 'data/firestore/useHttpMutation';

export default () => useHttpMutation({
    method: 'DELETE',
    server: process.env.REACT_APP_BASE_URL,
});
